import { ShieldCheck, Leaf, Clock3, Sparkles } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { IMG, BG } from "../lib/data";
import { useLang } from "../lib/i18n";
import { SectionBg } from "./SectionBg";

const PROMISE_ICONS = [ShieldCheck, Leaf, Clock3, Sparkles];

export default function About() {
  const { t } = useLang();
  return (
    <section id="about" className="relative py-24 lg:py-32 overflow-hidden">
      <SectionBg src={BG.about} opacity={0.26} testid="about-bg-image" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14 lg:gap-20 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <Reveal>
            <div className="relative rounded-3xl overflow-hidden border border-white/10">
              <img
                src={IMG.about}
                alt="OGO crew deep-cleaning a home interior"
                className="w-full h-[420px] sm:h-[520px] object-cover hover:scale-105 transition-transform duration-[1400ms]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 rounded-2xl border border-white/10 bg-ink/70 backdrop-blur-xl px-5 py-4">
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">{t.about.badgeTag}</p>
                <p className="text-white text-sm font-medium mt-1">{t.about.badgeText}</p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <SectionHead
            align="left"
            tag={t.about.tag}
            title={t.about.title}
            sub={t.about.sub}
          />

          <div className="grid sm:grid-cols-2 gap-5 mt-12">
            {t.about.promises.map(({ t: title, d }, i) => {
              const Icon = PROMISE_ICONS[i];
              return (
                <Reveal key={title} delay={0.08 * i}>
                  <div className="group h-full rounded-2xl border border-white/10 bg-panel/60 p-6 hover:border-gold/40 hover:-translate-y-1 transition-all duration-500">
                    <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-gold/10 border border-gold/25 text-gold group-hover:scale-110 transition-transform duration-500">
                      <Icon size={19} strokeWidth={2.1} />
                    </span>
                    <h3 className="font-display font-bold text-white text-lg mt-4">{title}</h3>
                    <p className="text-slate-400 text-sm leading-relaxed mt-2">{d}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
